module.exports = __webpack_public_path__ + "img/dw.e911c0c6.svg";